export default __webpack_public_path__ + "static/sc-dev2-5faf610850f99f9e5972fba4c0e6ddd9.webp";